import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::exportMethod
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:53
* @route '/reports/bookings/export'
*/
export const exportMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

exportMethod.definition = {
    methods: ["get","head"],
    url: '/reports/bookings/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::exportMethod
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:53
* @route '/reports/bookings/export'
*/
exportMethod.url = (options?: RouteQueryOptions) => {
    return exportMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::exportMethod
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:53
* @route '/reports/bookings/export'
*/
exportMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::exportMethod
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:53
* @route '/reports/bookings/export'
*/
exportMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exportMethod.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::exportMethod
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:53
* @route '/reports/bookings/export'
*/
const exportMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::exportMethod
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:53
* @route '/reports/bookings/export'
*/
exportMethodForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::exportMethod
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:53
* @route '/reports/bookings/export'
*/
exportMethodForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

exportMethod.form = exportMethodForm

const bookings = {
    export: Object.assign(exportMethod, exportMethod),
}

export default bookings